import React from 'react';

const SvgOm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="OM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="OM_svg__b" fill="#fff">
        <use xlinkHref="#OM_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#138E16" mask="url(#OM_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        fill="#ED2B35"
        mask="url(#OM_svg__b)"
        d="M0 20h9.333v-6.667H28V6.667H9.333V0H0z"
      />
      <path
        fill="#FFF"
        mask="url(#OM_svg__b)"
        d="M4.667 4.712L3.51 6.402l.6-1.958-2.043.15 1.906-.752-1.391-1.505L4.358 3.36l.309-2.026.308 2.026 1.777-1.022L5.36 3.842l1.905.751-2.043-.15.6 1.96z"
      />
    </g>
  </svg>
);

export default SvgOm;
